// @ts-nocheck
import { VOTE_ERROR, VOTE_LOADING, VOTE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const VoteReducer = (state = initialState, action) => {
    switch (action.type) {
        case VOTE_LOADING:
            return Object.assign({}, state, { loading: true })
        case VOTE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case VOTE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

